import _implicitStylesheets from "./avatar.css";
import _implicitScopedStylesheets from "./avatar.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<img${"a0:src"}${"a0:alt"}${3}>`;
const stc0 = {
  classMap: {
    "default-icon": true
  },
  key: 1
};
const stc1 = {
  props: {
    "icon": "user",
    "ariaHidden": "true"
  },
  key: 2
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element, h: api_element, b: api_bind, sp: api_static_part, st: api_static_fragment} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.className),
    key: 0
  }, [$cmp.renderDefault ? api_element("div", stc0, [api_custom_element("ax-icon", _axIcon, stc1)]) : null, !$cmp.renderDefault ? api_static_fragment($fragment1, 4, [api_static_part(0, {
    on: {
      "error": _m1 || ($ctx._m1 = api_bind($cmp.handleError))
    },
    attrs: {
      "src": $cmp.src,
      "alt": $cmp.alt
    }
  }, null)]) : null])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-rtsm8c1m7e";
tmpl.legacyStylesheetToken = "undefined-_avatar";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
